import styled from 'styled-components'
import { colors } from '../../theme'

/*
 * Tela de selecao de organizacao.
 *
 * Os nomes exportados sao os mesmos de antes — `index.tsx` nao mudou. O que
 * mudou foi o desenho:
 *  - a lista virou um POCO (`grey100`) dentro do cartao (`surface`). Antes as
 *    duas superficies eram a mesma cor e a area rolavel era invisivel;
 *  - o item selecionado deixou de se distinguir so pela cor da borda e passou a
 *    ter fundo tingido + barra de acento a esquerda;
 *  - o nome da organizacao — que e o conteudo principal da tela — era `grey600`
 *    (cor de texto secundario) e passou a `grey900`;
 *  - a lupa era um <button> em `left: 217px`, coordenada magica casada com a
 *    largura do input; virou posicionamento pela direita e sem captura de
 *    clique, para nao roubar o foco do campo.
 */

export const ContainerOrganizationListStyle = styled.div`
  position: fixed;
  inset: 0;
  z-index: 2001;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow-y: auto;
  background-color: ${colors.overlay};
  backdrop-filter: blur(2px);
`

export const OrganizationStyle = styled.div`
  width: min(560px, 100%);
  background-color: ${colors.surface};
  border: 1px solid ${colors.grey300};
  border-radius: 16px;
  padding: 28px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.55);
  text-align: left;

  h1 {
    color: ${colors.grey900};
    font-weight: 600;
    font-size: 18px;
    line-height: 1.3;
    margin: 0;
    white-space: nowrap;
  }
`

export const Search = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 18px;

  @media screen and (max-width: 520px) {
    flex-direction: column;
    align-items: stretch;

    h1 {
      white-space: normal;
    }
  }
`

export const DivInput = styled.div`
  position: relative;
  flex: none;
`

export const InputStyle = styled.input<{
  sizeY: string
  sizeX: string
}>`
  outline: none;
  width: ${({ sizeX }) => sizeX};
  height: ${({ sizeY }) => sizeY};
  max-width: 100%;
  background-color: ${colors.grey100};
  border: 1px solid ${colors.grey300};
  border-radius: 10px;
  padding: 0 14px 0 38px;
  font-size: 12px;
  color: ${colors.grey900};

  &::placeholder {
    color: ${colors.grey500};
  }

  &:focus {
    border-color: ${colors.secondary};
  }
`

/* Decorativa: a lupa nao tem acao propria, entao nao pode receber clique nem
   tirar o foco do campo ao lado. */
export const Span = styled.button`
  position: absolute;
  top: 50%;
  left: 12px;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  padding: 0;
  border: none;
  background-color: transparent;
  pointer-events: none;

  svg {
    width: 14px;
    height: 14px;
  }
`

export const ListStyle = styled.div`
  width: 100%;
  height: 260px;
  overflow-y: auto;
  background-color: ${colors.grey100};
  border: 1px solid ${colors.grey300};
  border-radius: 12px;
  padding: 8px;
  margin-bottom: 22px;

  &::-webkit-scrollbar {
    width: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: ${colors.grey400};
    border-radius: 8px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
`

export const OrganizationListStyle = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 4px;
  font-weight: 400;
  font-size: 13px;
  text-decoration: none;

  &:last-child {
    margin-bottom: 0;
  }
`

export const OrganizationFrame = styled.div`
  position: relative;
  width: 100%;
  padding: 11px 14px;
  text-align: left;
  border: 1px solid transparent;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease;

  :hover {
    background-color: ${colors.surfaceHigh};
    border-color: ${colors.grey400};
  }
`

/* Selecionado: fundo tingido + barra de acento. So a borda verde (o desenho
   anterior) some numa lista longa — e a barra sobrevive ao scroll rapido. */
export const OrganizationFrameActive = styled.div`
  position: relative;
  width: 100%;
  padding: 11px 14px 11px 18px;
  text-align: left;
  border: 1px solid ${colors.secondary};
  border-radius: 10px;
  background-color: ${colors.lightGreen};
  cursor: pointer;

  ::before {
    content: '';
    position: absolute;
    top: 8px;
    bottom: 8px;
    left: 6px;
    width: 3px;
    border-radius: 3px;
    background-color: ${colors.secondary};
  }
`

export const Organization = styled.button`
  width: 100%;
  padding: 0;
  text-align: left;
  font-weight: 500;
  font-size: 13px;
  background-color: transparent;
  border: none;
  color: ${colors.grey900};
  cursor: pointer;
`

export const ButtonOrganizationListStyle = styled.button`
  width: 100%;
  height: 44px;
  background-color: ${colors.accentBg};
  border-radius: 12px;
  padding: 0 18px;
  color: ${colors.white};
  border: none;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    filter: brightness(1.08);
  }
`

export const SelecioneUmaOrganizacao = styled.div`
  margin-top: 12px;
  font-size: 12px;
  text-align: center;
  color: ${colors.errorText};
`
